import React from 'react'
const ThowColumLayout = ({ colum1, colum2, background }) => {

    const container = {
        "background": background,
        "display": "grid",
        "gridTemplateColumns": "229px 1fr",
    }

    const colum1Layout = {
        gridColumnStart: '1',
        gridColumnEnd: '2',
    }

    const colum2Layout = {
        gridColumnStart: '2',
        gridColumnEnd: '2',
        backgroundColor: "#F9F9F9",
        overflowY: "auto",
        paddingLeft: "6rem",
        paddingRight: "6rem",
        height: "100vh"
    }

    return (
        <div style={container}>
            <div style={colum1Layout}>
                {colum1}
            </div>

            <div style={colum2Layout}>
                {colum2}
            </div>

        </div>
    )

}

export default ThowColumLayout